"use strict"
var schoolside = angular.module('schoolside', ['applications', 'navBar', 'settings', 'reports', 'vouchers', 'firstRun', 'committeeMode',
    'informationService', 'applicationsSubNavbar', 'userSchoolModel', 'messageModel', 'message', 'feedback', 'firstRunModel',
    'firstRunTrackingModel', 'medianExpenseModel', 'resources', 'emailBlast']);
var controllers = {};
controllers.SchoolSideController = function($scope, SchoolModelService, BinFactory, UserSchoolModelService,
                                            ApplicationsSubNavbarService, RestService, $location, MessageModelService,
                                            HelpSystemModelService, $timeout, MessageModalService, FirstRunModelService,
                                            FirstRunModalService, authServiceFactory, MedianExpenseModelService, ApplicationService) {
    $scope.school = SchoolModelService.get();
    $scope.ApplicationsSubNavbarService = ApplicationsSubNavbarService;
    $scope.RestService = RestService;
    $scope.versionNo = versionNo;
    $scope.authServiceFactory = authServiceFactory;
    $scope.ApplicationService = ApplicationService;
    $(".index-loading-area").addClass("hidden");
    $scope.$on("reloadBins", function (event) {
        BinFactory.retrieveData();

    });

    // Log version on page load
    RestService.post("/api/VersionLog", {
        schoolID: authServiceFactory.getAuth().schoolID,
        contactID: authServiceFactory.getAuth().recordID,
        version: versionNo
    }); 

};
schoolside.controller(controllers);

stateProviders.push({
    name: 'schoolside',
    url: '/schoolside',
    abstract: true,
    templateUrl: 'fast/submodules/schoolside/schoolside.html?v=' + versionNo,
    controller: 'SchoolSideController',
    resolve : {
        userSchoolModel: function(UserSchoolModelService, authServiceFactory, $location)
        {
            return UserSchoolModelService.resolveData(authServiceFactory.getAuth().token);
        },
        message: function(MessageModelService, authServiceFactory)
        {
            return MessageModelService.get(authServiceFactory.getAuth().schoolID)
        },
        firstRun:function(FirstRunModelService, authServiceFactory)
        {
            return FirstRunModelService.get(authServiceFactory.getAuth().schoolID)
        },
        committeeMode: function (CommitteeModeModelService, authServiceFactory)
        {
           return CommitteeModeModelService.get(authServiceFactory.getAuth().schoolID)
        },
        permissions: function (PermissionModelService, authServiceFactory)
        {
           return PermissionModelService.get(authServiceFactory.getAuth().schoolID)
        },
        medianExpense: function (MedianExpenseModelService, authServiceFactory)
        {
            return MedianExpenseModelService.get(authServiceFactory.getAuth().schoolID)
        }
    }
});
